import React, {Component} from 'react';
import PropTypes from "prop-types";
import CompanyAddContainer from "./CompanyAddContainer";
import CompanyEditContainer from "./CompanyEditContainer";
import CompanyOverviewContainer from "./CompanyOverviewContainer";

class CompaniesContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: null,
            companyEdit: null
        };

        this.translate = this.props.baseData.translate;

        this.changeView = this.changeView.bind(this);

    }

    changeView(activeView = null, companyEdit = null) {

        this.setState({
            activeView,
            companyEdit
        });

    }

    renderView() {

        const activeView = this.state.activeView;

        if (activeView === 'add') {
            return <CompanyAddContainer
                baseData={this.props.baseData}
                timezones={this.props.timezones}
                changeView={this.changeView}
            />;
        } else if (activeView === 'edit') {
            return <CompanyEditContainer
                baseData={this.props.baseData}
                company={this.state.companyEdit}
                timezones={this.props.timezones}
                changeView={this.changeView}
            />;
        } else {
            return <CompanyOverviewContainer
                baseData={this.props.baseData}
                timezones={this.props.timezones}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderView = this.renderView();

        return (
            <div className="clearfix">
                {renderView}
            </div>
        );

    }

}

export default CompaniesContainer;